import React, { useEffect, useRef, useState } from 'react'
import IconTint from 'react-icon-tint';
import downIcon from '../assets/icons/ic_arrowdown.svg'
import upIcon from '../assets/icons/ic_arrowup.svg'

const Dropdown = ({
    list: items = [],
    setSelected: setSelectedItem,
    selectedItem: selected,
    dropdownWidth,
    className = '',
    buttonClassName = '',
    menuClassName = '',
    fullWidth = false,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const myComponentRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (myComponentRef.current && !myComponentRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const onSelected = (item) => {
        setSelectedItem(item);
        setIsOpen(false);
    };

    const widthStyle = dropdownWidth ? { minWidth: `${dropdownWidth}px` } : undefined;

    return (
        <div
            ref={myComponentRef}
            className={`relative mt-1 select-none transition-all delay-200 ${fullWidth ? 'w-full' : 'w-fit'} ${className}`}
        >
            <button
                type="button"
                onClick={() => setIsOpen((prev) => !prev)}
                style={widthStyle}
                className={`flex items-center justify-between bg-[#3C5BD2] bg-opacity-10 px-3 py-2 text-left focus:outline-none ${fullWidth ? 'w-full' : 'w-fit'} ${isOpen ? 'rounded-bl-none rounded-br-none rounded-t-md' : 'rounded-md hover:bg-opacity-20'} ${buttonClassName}`}
            >
                <span className="min-w-0 truncate font-heebo font-light">{selected}</span>
                {!isOpen ? (
                    <IconTint src={downIcon} className='ml-3 h-3 w-3 flex-shrink-0' color='#3C5BD2' />
                ) : (
                    <IconTint src={upIcon} className='-mt-1 ml-3 h-3 w-3 flex-shrink-0' color='#3C5BD2' />
                )}
            </button>

            {isOpen && (
                <div className={`absolute left-0 z-10 mt-[1px] w-full rounded-b-md bg-[#e1e6fd] py-2 shadow-xl ${menuClassName}`}>
                    {items.map((item, index) => (
                        <button
                            key={index}
                            type="button"
                            className="block w-full px-4 py-1.5 text-left font-heebo text-md font-light hover:bg-[#b9c7ff] hover:bg-opacity-20"
                            onClick={() => onSelected(item)}
                        >
                            {item}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Dropdown
